m = require 'mithril'

ActionFactories = require '../../state/ActionFactories'

CommonViews 	= require '../components/CommonViews'
Breadcrumbs 	= require '../components/Breadcrumbs'
ControlBlock 	= require '../components/ControlBlock'
DeleteButton 	= require '../components/DeleteButton'
GameView 		= require '../components/GameView'
GameViewOptions = require '../components/GameViewOptions'
GameDetails 	= require '../components/GameDetails'
GameChart 		= require '../components/GameChart'

GamePage = {
	controller: (args) -> {
		showGraphs: m.prop false
		onGameRemoved: (gameId) ->
			args.onGameRemoved gameId
			m.route '/'
		onViewGames: () ->
			m.route '/'
		onRoundAdded: () ->
			game = args.game()
			numberOfExistingRounds = game.rounds.length
			args.onRoundAdded game.id
			console.log "/game/#{game.id}/numberOfExistingRounds"
			m.route "/game/#{game.id}/#{numberOfExistingRounds}"
	}

	view: (ctrl, args) ->
		game = args.game()

		CommonViews.page [
			m Breadcrumbs, {items: [
				{url: '/', label: 'Games', icon: CommonViews.icons.home}
				{label: "#{game.label} (#{game.date})", icon: CommonViews.icons.spades}
			]}

			CommonViews.pageHeading game.label
			m GameView, {game: game}
			m GameViewOptions, {showGraphs: ctrl.showGraphs}

			if ctrl.showGraphs()
				m GameChart, {game}
			else
				m GameDetails, {game, onRoundAdded: ctrl.onRoundAdded}
			
			m 'hr'

			m ControlBlock, {
				content: m DeleteButton, {
						message: 'If you created this game in error then click delete to permanently remove it.'
						label: 'Delete game'
						onclick: ctrl.onGameRemoved.bind(ctrl, game.id)
					}
			}
		]
}

module.exports = (store) ->
	m.component GamePage, {
		onGameRemoved: (gameId) -> store.dispatch ActionFactories.gameRemoved gameId
		onRoundAdded: (gameId) -> store.dispatch ActionFactories.roundAdded gameId
		game: () -> store.getState().gamesById[m.route.param 'id']
	}